import { createContext, useContext } from "react";

const PolyglotContext = createContext();

const usePolyglotContext = () => {
  return useContext(PolyglotContext);
};

export { PolyglotContext, usePolyglotContext };
